export const locales = {
    EN: 'en-US',
    ES: 'es'
};

export const languages = [{label: 'English', value: locales.EN}, {label: 'Español', value: locales.ES}];